// extracted by mini-css-extract-plugin
export default {"topicTitle":"nRp6JQCG","scrollButton":"rWhBFs1k","scrollButtonText":"ptXQL4mY"};